import { planTypes } from "utils/Types";
import { Comments } from "./Comments";
import CardDialogDetails from "./index";

export const TabsConfig = (planType: string | null) => {
  const commonTabs = [
    {
      label: "Info",
      content: CardDialogDetails
    }
  ];

  return planType === planTypes.AllPlans || planType === planTypes.MulipleAssign || planType === "TemplatePlan"
    ? [...commonTabs]
    : [
        ...commonTabs,
        {
          label: "Comments",
          content: Comments
        }
      ];
};
